import { AgTechDataAction } from "@agtech/core/data/actions/AgTechDataActions";
import { useAgTechHttpDeleteRequest } from "@agtech/core/data/http/AgTechApiDeleteRequests";
import { useAgTechHttpPostRequest } from "@agtech/core/data/http/AgTechApiPostRequests";
import { OperationDataGetRoleAssignmentsQuery } from "./OperationRoleQueries";

export type UserRoleActionDTO = {
    userId: number,
    roleId: number
}

export const useOperationRoleAssignAction = (): AgTechDataAction<UserRoleActionDTO, boolean> => {
    let assignRequest = useAgTechHttpPostRequest<number[], boolean>();

    return {
        name: 'AssignRole',
        getConfiguration: () => ({
            actionExecutionMessage: 'Assigning role...',
            actionConfirmationMessage: 'Successfully assigned role',
            showConfirmationMessage: false
        }),
        action: props => assignRequest.post({
            path: `Operation/Users/${props.submittedEntity.userId}/Roles`,
            postedData: [props.submittedEntity.roleId]
        }),
        onSuccess: async props => {
            props.invalidateQuery({
                query: OperationDataGetRoleAssignmentsQuery
            });
        }
    }
}

export const useOperationRoleRemoveAction = (): AgTechDataAction<UserRoleActionDTO, boolean> => {
    let removeRequest = useAgTechHttpDeleteRequest();

    return {
        name: 'RemoveRole',
        getConfiguration: () => ({
            actionExecutionMessage: 'Removing role...',
            actionConfirmationMessage: 'Successfully removed role',
            showConfirmationMessage: false
        }),
        action: props => removeRequest.delete({
            path: `Operation/Users/${props.submittedEntity.userId}/Roles/${props.submittedEntity.roleId}`
        }),
        onSuccess: async props => {
            props.invalidateQuery({
                query: OperationDataGetRoleAssignmentsQuery
            });
        }
    }
}
